import find from 'lodash/fp/find';
import formatTypes from '../../../node_modules/@suunto/suunto-information-model/Specifications/ValuesAndFormatting/FormatTypes.json';
import unitTypes from '../../../node_modules/@suunto/suunto-information-model/Specifications/ValuesAndFormatting/UnitTypes.json';

export function getFormatStyles() {
  const styles = {};
  Object.keys(formatTypes).forEach((type) => {
    const formatType = formatTypes[type];
    const styleObj = formatType.Metric ? formatType.Metric.Styles : formatType.Generic.Styles;
    styles[type] = Object.keys(styleObj);
  });
  return styles;
}
export function getSuffix(type, unitSystem, style, suffixTranslator, value = null) {
  // When the sports data is illegal, the corresponding unit cannot be retrieved, and the program will report an error, causing the page to not display properly,please refer to the comments on bug #163425
  try {
    const formatObj = formatTypes[type];
    let unitSettings = unitSystem === 'metric' ? formatObj.Metric : formatObj.Imperial;
    if (!unitSettings) {
      unitSettings = formatObj.Generic;
    }
    let formatting = unitTypes[unitSettings.Styles[style][0].Unit];
    if (value) {
      let styleSettings = style ? unitSettings.Styles[style] : null;
      if (!styleSettings) {
        styleSettings = unitSettings.Styles[formatObj.DefaultStyle];
      }
      formatting = unitTypes[find((setting) => value <= setting.Range.Max)(styleSettings).Unit];
    }
    return suffixTranslator(formatting);
  } catch (error) {
    console.error('An error occurred:', error);
    return null;
  }
}

export default { getFormatStyles, getSuffix };
